<template>
  <div class="d-flex flex-column ga-8">
    <div class="ClosdTagLine__title">{{$t('login.ClosdTagLine.header')}}</div>

    <div class="d-flex flex-column ga-5">
      <div class="d-flex align-center ga-4">
        <div class="tile__visual">
          <app-material-icon name="signature" color="icon-blue" />
        </div>
        <h3 class="ClosdTagLine__infoText text-text-primary">{{$t('login.ClosdTagLine.signature')}}</h3>
      </div>

      <div class="d-flex align-center ga-4">
        <div class="tile__visual">
          <app-material-icon name="shield" color="icon-blue" />
        </div>
        <h3 class="ClosdTagLine__infoText text-text-primary">{{$t('login.ClosdTagLine.security')}}</h3>
      </div>

      <div class="d-flex align-center ga-4">
        <div class="tile__visual">
          <app-material-icon name="docs" color="icon-blue" />
        </div>
        <h3 class="ClosdTagLine__infoText text-text-primary">{{$t('login.ClosdTagLine.project')}}</h3>
      </div>
    </div>
    <div class="d-flex flex-column ga-2 ClosdTagLine__infoText">
      <p>{{$t('login.ClosdTagLine.paragraphOne')}}</p>
      <p>{{$t('login.ClosdTagLine.paragraphTwo')}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClosdTagLine',
}
</script>

<style lang="scss" scoped>
.ClosdTagLine {
  &__title {
    font-size: 36px;
    font-weight: 300;
    color: rgb(var(--v-theme-text-primary));
  }
  &__infoText {
    font-size: 16px;
    color: rgb(var(--v-theme-text-secondary));
  }
}

.tile__visual {
  background-color: rgb(var(--v-theme-surface-blue-subtle));
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  overflow: hidden;
}
</style>
